import { render } from "./BreadcrumbItem.vue?vue&type=template&id=88401442"
import script from "./BreadcrumbItem.vue?vue&type=script&lang=js"
export * from "./BreadcrumbItem.vue?vue&type=script&lang=js"

import "./BreadcrumbItem.vue?vue&type=style&index=0&id=88401442&lang=scss"
script.render = render

export default script